import React from 'react';
import {queryClient} from '../queryClient';

import {QueryClientProvider} from '@tanstack/react-query';

export const withQueryClient = function <C extends React.ElementType>(
	Component: C,
) {
	return (
		props: JSX.IntrinsicAttributes &
			JSX.LibraryManagedAttributes<C, React.ComponentProps<C>>,
	) => {
		return (
			<QueryClientProvider client={queryClient}>
				<Component {...props} />
			</QueryClientProvider>
		);
	};
};
